<page-header [listeItems]="listeTabItems"
			 [title]="isCreation ? ('admin.frais.indemnites.fraisMissions.detail.titleCreation' | translate) : ('admin.frais.indemnites.fraisMissions.detail.titleModification' | translate)"
			 (onGoBack)="onBack()">
</page-header>

<div *ngIf="fraisMission">
	<form #fraisMissionForm="ngForm">
		<!-- Généralités -->
		<mat-card>
			<mat-card-title><span [translate]="'admin.frais.indemnites.fraisMissions.detail.generalites.title'"></span></mat-card-title>
			<mat-card-content>
				<div class="row">
					<div class="col-md-6">
						<div class="row">
							<custom-input ngDefaultControl
										  id="territoire"
										  name="territoire"
										  [(ngModel)]="selectedGeographie"
										  customType="autocomplete"
										  autocompleteType="geographie"
										  [autocompleteFilter]="{ listeTypes: ['PAYS', 'VILLE', 'ZONE', 'REGION'] }"
										  optionDisplay="libelle"
										  [lCol]="5"
										  [rCol]="6"
										  libelle="admin.frais.indemnites.fraisMissions.detail.generalites.territoire"
										  [required]="true"
										  [readonly]="!isCreation || isTauxSpecialFromTerritoire"
										  (onChange)="onTerritoireChange($event)">
							</custom-input>
							<!-- Bouton recherche avancée -->
							<button *ngIf="isCreation && !isTauxSpecialFromTerritoire" mat-icon-button class="territoire-search-btn" (click)="openTerritoirePopin()"
									[matTooltip]="'admin.frais.indemnites.fraisMissions.detail.generalites.rechercheAvancee' | translate">
								<mat-icon>manage_search</mat-icon>
							</button>
						</div>

						<div class="row">
							<custom-input ngDefaultControl
										  id="periodeMin"
										  name="periodeMin"
										  [(ngModel)]="fraisMission.periodeMin"
										  (ngModelChange)="onPeriodeChange()"
										  customType="number"
										  [lCol]="5"
										  [rCol]="2"
										  libelle="admin.frais.indemnites.fraisMissions.detail.generalites.periodeValidite"
										  [required]="true"
										  [min]="1"
										  rClass="periode-input-small">
							</custom-input>

							<div class="col-auto px-2 pt-3">
								<span [translate]="'admin.frais.indemnites.fraisMissions.detail.generalites.periodeA'"></span>
							</div>

							<custom-input ngDefaultControl
										  id="periodeMax"
										  name="periodeMax"
										  [(ngModel)]="fraisMission.periodeMax"
										  (ngModelChange)="onPeriodeChange()"
										  customType="number"
										  [rCol]="2"
										  [lCol]="0"
										  rClass="periode-input-small">
							</custom-input>
							<div class="col-auto px-2 pt-3">
							 <span>
								<span [translate]="'admin.frais.indemnites.fraisMissions.detail.generalites.periodeJours'"></span>
								<mat-icon class="material-icons-outlined ml-2" style="vertical-align: middle; font-size: 18px;"
										  [matTooltip]="'admin.frais.indemnites.fraisMissions.detail.generalites.periodeTooltip' | translate">
									info
								</mat-icon>
							</span>
							</div>
						</div>
					</div>

					<div class="col-md-6">
						<div class="row">
							<custom-input *ngIf="isCreation || fraisMission.hasTauxSpecial"
										  ngDefaultControl
										  id="hasTauxSpecial"
										  name="hasTauxSpecial"
										  [ngModel]="fraisMission.hasTauxSpecial"
										  (ngModelChange)="onHasTauxSpecialChange()"
										  [(customModel)]="fraisMission.hasTauxSpecial"
										  customType="checkbox"
										  [lCol]="4"
										  [rCol]="8"
										  [readonly]="!isCreation"
										  libelle="admin.frais.indemnites.fraisMissions.detail.generalites.tauxSpecial"
										  postLibelle="admin.frais.indemnites.fraisMissions.detail.generalites.tauxSpecialPostLibelle">
							</custom-input>
						</div>

						<div class="row">
							<custom-input *ngIf="isCreation || fraisMission.hasTauxSpecial"
										  ngDefaultControl
										  id="libelleSpecial"
										  name="libelleSpecial"
										  [(ngModel)]="fraisMission.libelleSpecial"
										  customType="input"
										  [lCol]="4"
										  [rCol]="6"
										  libelle="admin.frais.indemnites.fraisMissions.detail.generalites.libelleTauxSpecial"
										  [required]="fraisMission.hasTauxSpecial"
										  [readonly]="!isCreation"
										  [disabled]="!fraisMission.hasTauxSpecial"
										  [postTooltipNio]="{content: ('admin.frais.indemnites.fraisMissions.detail.generalites.libelleTauxSpecialTooltip' | translate)}">
							</custom-input>
						</div>
					</div>
				</div>
			</mat-card-content>
		</mat-card>

		<!-- Dates d'application -->
		<list-view [liste]="listeViewDatesApplication" *ngIf="listeViewDatesApplication && fraisMissionForm.valid"></list-view>
	</form>
</div>

<floating-button [listeActions]="listeActions"></floating-button>